const cart = () => {
	const cartButtons = document.querySelectorAll('.js-navbar__cart__button')
	if(cartButtons) {

		cartButtons.forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault()
				const ev = new Event("viwcaio_fragment_refresh");
				document.dispatchEvent(ev);
				if (typeof vi_wcaio_sc_toggle === 'function') {
					vi_wcaio_sc_toggle('show');
				}
				removePromoProducts();
			})
		});

	}
}

const removePromoProducts = () => {
	const sidecartProducts = document.querySelectorAll('.vi-wcaio-sidebar-cart-products li:not(.vi-wcaio-sidebar-cart-pd-empty)');
	if(sidecartProducts.length > 0)	 {
		document.querySelector('.sidecart__products-empty-wrapper').classList.add('hidden')
	} else {
		document.querySelector('.sidecart__products-empty-wrapper').classList.remove('hidden')
	}
}

export default cart
